import service from './baseService';

export const getProfile = () => {
    return service.get(`/profile`);
};
